// Author: YuFeng Deng
import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmptyInputValue } from './shared';

export class LessEqualValidator {
  static factors: any = {
    'ms': 1,
    's': 1000,
    'm': 60 * 1000,
    'h': 60 * 60 * 1000,
    'd': 24 * 60 * 60 * 1000,
  };

  public static lessEqual(
    unitControl: AbstractControl,
    control2: AbstractControl,
    unitControl2: AbstractControl,
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null; // don't validate empty values to allow optional controls
      }
      if (isEmptyInputValue(unitControl.value)) {
        return null; // don't validate empty values to allow optional controls
      }

      const control1Value = this.convertToBaseValue(control.value, unitControl.value);
      const control2Value = this.convertToBaseValue(control2.value, unitControl2.value);

      if (control1Value == null || !control2Value == null) {
        return { 'lessEqual': true };
      }

      if (control1Value > control2Value) {
        return { 'lessEqual': true };
      }

      return null;
    };
  }
  static convertToBaseValue(value: number, unit: string) {
    if (!this.factors[unit]) {
      return null;
    }
    return value * this.factors[unit];
  }
}
